import getTranslation from '../getTranslation';
import { getDictionary } from '../selectors/getDictionary';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';

export const useTranslator = (key, fallback, replaceWith = undefined) => {
    const dictionary = useSelector(getDictionary);
    return useMemo(() => getTranslation(dictionary, key, fallback, replaceWith), [dictionary, key, fallback, replaceWith]);
};
